import { Box, Typography, Divider, TextField, Button, Collapse, Alert, CircularProgress, List, Paper } from "@mui/material"
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { RoleControllerAction, RoleControllerState } from "../../controller/role.controller";
import CloseButton from '../../../../components/closebutton/CloseButton';
import NumberInputCustom from "../../../../components/NumberPicker/CustomNumberInput";
import { useState } from "react";
import { roleRefData } from "../../data/role-data-ref";

const RoleModalCreate = ({ ctrl }: { ctrl: RoleControllerState & RoleControllerAction }) => {
    const [open, setOpen] = useState(false);
    return (
        <Box sx={{ width: '100%' }}>
            <Box padding={4}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography fontSize="24px">ສ້າງບົດບາດໃໝ່</Typography>
                    <CloseButton onClick={() => ctrl.onHandleModal(null)} />
                </Box>
                <Divider sx={{ backgroundColor: '#1A1A1A20', mt: 1.5 }} />

                <Paper style={{ maxHeight: "600px", overflow: 'auto' }}>
                    <List>
                        <Collapse unmountOnExit={true} orientation={"vertical"} in={ctrl?.message ? true : false} >
                            <Alert severity={"error"}>{ctrl?.message ?? ""}</Alert>
                        </Collapse>
                        <Box marginTop={"50px"} marginBottom={"20px"} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                            <TextField
                                fullWidth
                                size="small"
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                label="ຊື່ບົດບາດ"
                                placeholder="please enter"
                                value={ctrl.formCreate?.role_name}
                                onChange={(e) => ctrl.onUpdateFormCreate({ ...ctrl.formCreate, role_name: e.target.value })}
                            />
                            <Box paddingLeft={"20px"} width={"40%"} display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                <Typography sx={{ textWrap: "nowrap", paddingRight: "20px" }}>
                                    ເລເວລ:
                                </Typography>
                                <NumberInputCustom value={ctrl?.formCreate?.level} onChange={(value: number | null) => {
                                    if (value) {
                                        if (value > 5 || value < 1) {
                                            ctrl.setMessage(`ເລກ ເລເວລ ບໍ່ໄດ້ຢູ່ໃນຂອບເຂດທີ່ກຳນົດໄວ້! (${roleRefData.map(item => item.level).join(", ")})`);
                                        } else {
                                            ctrl.onUpdateFormCreate({ ...ctrl.formCreate, level: value });
                                        }
                                    }
                                }} />
                            </Box>
                        </Box>
                        <TextField
                            fullWidth
                            size="small"
                            multiline
                            rows={4}
                            InputLabelProps={{ shrink: true }}
                            label="ເນື້ອໃນ"
                            placeholder="ປ້ອນຄໍາອະທິບາຍ"
                            value={ctrl.formCreate?.description}
                            onChange={(e) => ctrl.onUpdateFormCreate({ ...ctrl.formCreate, description: e.target.value })}
                        />
                        <Box sx={{ flexDirection: "row", display: "flex", marginTop: "20px", alignItems: "center", marginBottom: "10px" }}>
                            <ReportIcon sx={{ color: "#DCDCDC", width: "16px", marginRight: "3px" }} />
                            <Typography sx={{ color: "#808080", fontSize: 13 }}>
                                ເລເວລບົດບາດຜູ້ໃຊ້ງານໃນລະບົບ (Role) ແມ່ນຖືກຈຳກັດໄວ້ທີ່ 5 ຂັ້ນ,
                            </Typography>
                            <Typography onClick={() => {
                                setOpen(!open);
                            }} sx={{ color: "blue", fontSize: 13, marginLeft: "5px", cursor: "pointer" }}>
                                {open ? "ປິດໜ້າຕ່າງ?" : "ເພີ່ມເຕີມ?"}
                            </Typography>
                        </Box>
                        <Collapse unmountOnExit={true} orientation={"vertical"} in={open}>
                            <Box sx={{ borderRadius: "10px", background: "#F8F8F8", padding: "15px" }}>
                                {roleRefData.map((x, y) => {
                                    const createdRoles = ctrl?.listRole ?? [];
                                    const foundIndex = createdRoles.findIndex((q) => q.level === x.level);
                                    return (
                                        <Box key={y}>
                                            <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center" }}>
                                                {foundIndex < 0 ? <RadioButtonUncheckedIcon sx={{ color: "#D3D3D3", width: "16px", }} /> :
                                                    <CheckCircleIcon sx={{ color: "#808080", width: "16px", }} />}
                                                <Typography sx={{ color: "#808080", fontSize: 13, marginLeft: "5px", cursor: "pointer" }}>ເລເວລ: {x.level} - {x.name}</Typography>
                                            </Box>
                                            <Typography sx={{ color: "#808080", fontSize: 13, fontStyle: "italic", paddingLeft: "16px" }}>
                                                {x.descriptions.join(", ")}
                                            </Typography>
                                        </Box>
                                    )
                                })}
                            </Box>
                        </Collapse>
                    </List>
                </Paper>
                <Box sx={{ display: 'flex', gap: 2, mt: "15px" }}>
                    <Button
                        onClick={() => ctrl.onHandleModal(null)}
                        sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
                        variant="outlined"
                        size="small"
                        fullWidth
                    >
                        ຍົກເລີກ
                    </Button>
                    <Button
                        disabled={ctrl?.message ? true : false}
                        onClick={() => ctrl?.onSubmitForm(ctrl?.formCreate)}
                        sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
                        size="small"
                        fullWidth
                        variant="contained"
                    >
                        <Collapse unmountOnExit={true} orientation={"horizontal"} in={ctrl?.loading ?? false} >
                            <CircularProgress size={"20px"} sx={{ color: "white", marginRight: "10px" }} />
                        </Collapse>
                        ບັນທຶກ
                    </Button>
                </Box>

            </Box>
        </Box>
    )
}

export default RoleModalCreate;